<template>
  <div>
    <v-sheet class="py-3 py-md-6" color="primary">
      <TitleWidget dark>
        {{ title }}
      </TitleWidget>
    </v-sheet>

    <LoadingWidget v-if="checking" />

    <v-container v-else class="pb-10 pb-md-13 pb-lg-16">
      <div class="d-flex justify-end">
        <v-btn @click="logout" depressed small>Sair</v-btn>
      </div>

      <LoadingWidget v-if="loading" />

      <div v-else class="mt-4">
        <v-simple-table fixed-header>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Name</th>
                <th class="text-left">Data</th>
                <th class="text-left">Link</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="({ title, date, link }, keyItems) in items"
                :key="keyItems"
              >
                <td>{{ title }}</td>
                <td>{{ formatDate(date) }}</td>
                <td width="140px">
                  <v-btn
                    color="transparent"
                    :href="link"
                    target="_blank"
                    depressed
                    x-small
                    fab
                  >
                    <v-icon size="16"> fa-external-link-alt </v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </v-container>
  </div>
</template>

<script>
import TitleWidget from "../components/widgets/TitleWidget.vue";
import LoadingWidget from "../components/widgets/LoadingWidget.vue";
import { formatDate } from "../utils/formatDate";

const _config = {
  mod: "research",
};

const _data = {
  title: "Pesquisas",
  checking: true,
  loading: true,
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list;
    },
  },
  methods: {
    formatDate,
    checkIn() {
      this.checking = true;

      const token = window.localStorage.getItem(`token`);
      const login = ["/"].includes(this.$route.path);

      if (token) {
        this.$auth
          .checkIn()
          .then(() => {
            if (login) this.$router.push({ path: "/" });
          })
          .catch(() => !login && this.$router.push({ path: "/" }))
          .finally(() => (this.checking = false));
      } else if (!login) {
        this.checking = false;
        this.$router.push({ path: "/" });
      } else {
        this.checking = false;
      }
    },
    logout() {
      this.$auth.logout().finally(() => this.$router.push({ path: "/" }));
    },
  },
  watch: {
    $route() {
      this.checkIn();
    },
  },
  created() {
    this.checkIn();

    const params = {
      AUTH_TOKEN: window.localStorage.getItem(`token`),
    };

    this.$rest(_config.mod)
      .get({ params })
      .finally(() => (this.loading = false));
  },
  components: {
    TitleWidget,
    LoadingWidget,
  },
};
</script>
